module.exports = __webpack_public_path__ + "static/media/skull.cd9cc844.png";